import Link from 'next/link'
import { GrayBackground, GrayBackgroundSmaller } from '../../svgs/backgrounds'

import PageBuilder from '../PageBuilder'
import PageHeader from './PageHeader'

interface CompanyPageProps {
	page: any
	companySiteData: any
	dynamicData: any
}

const CompanyPage = (props: CompanyPageProps) => {

	const { page, companySiteData, dynamicData } = props

	// console.log('Page page: ', page)

	return (
		<>
			<PageHeader page={page} />
			<PageBuilder contentBlocks={page.pageBuilder} dynamicData={dynamicData} />
		</>
	)
}

export default CompanyPage
